/**
 * Created by aleks on 29/03/2017.
 */
export class AppConfig{
   //static readonly BaseUrl = "http://localhost:53957/";

  // AS: суперпродакшн
  //public static readonly BaseUrl = "http://monitoring.shtrih-m.ru/api/";
  public static readonly BaseUrl = "http://api.monitoring.shtrih-m.ru/";
  //public static readonly BaseUrl = "http://api.mostaho.ru:81/";
  //public static readonly BaseUrl = "http://api.auto.ugmk-telecom.ru:80/";
  public static readonly apiBaseUrl = AppConfig.BaseUrl + 'api/';

  public static readonly loginUrl = AppConfig.BaseUrl + 'api/Account/Token';
  //public static readonly loginUrl = AppConfig.BaseUrl + 'api/api/Account/Token';

  // AS: google analytics
  public static readonly gaTrackerId = "UA-108454367-1";

  // AS: расстояние между соседними точками трека истории, при превышении которого разрывать линию, "вставлять разрыв"
  // AS: в метрах
  public static distanceBreakTrackLimit = 15000;
}



// WEBPACK FOOTER //
// ./src/config/appconfig.ts